// extracted by mini-css-extract-plugin
export default {"text":"PaymentFailed_text__m3Yb1","title":"PaymentFailed_title__q7q6p","container":"PaymentFailed_container__eHXge","contact":"PaymentFailed_contact__XrkON"};